var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.988 0C18.6529 0 21.2117 2.52551 21.2117 6.1448V16.5526C21.2117 20.1719 18.6529 22.6974 14.988 22.6974H6.22368C2.55878 22.6974 0 20.1719 0 16.5526V6.1448C0 2.52551 2.55878 0 6.22368 0H14.988ZM27.1733 3.59978C27.8375 3.26182 28.6168 3.29715 29.2508 3.69656C29.8849 4.09444 30.2632 4.78573 30.2632 5.54154V17.1568C30.2632 17.9141 29.8849 18.6039 29.2508 19.0017C28.9043 19.2183 28.517 19.3289 28.1266 19.3289C27.8012 19.3289 27.4759 19.2521 27.1717 19.097L24.9307 17.9663C24.1015 17.5454 23.587 16.7005 23.587 15.7619V6.93487C23.587 5.99472 24.1015 5.14981 24.9307 4.73196L27.1733 3.59978Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.498cf600e7743fc89f92beb163741376.svg";
export { ForwardRef as ReactComponent };